import React, { Component } from 'react';
import cn from 'classnames';
import Box from 'common/Box';
import { formatDate, toGB, formatDataAmount } from 'helpers/formatters';
import { SHORT_DATE_FORMAT } from 'app_constants';
import { timeLeftInCycle } from 'billing/cycles/utils';
import styles from './DataRemaining.module.css';
import { isUnlimited } from 'subscriptions/plans/utils';


export const formatRemainingData = (avail, used) => {
  let remaining = avail - used;
  if (remaining < 0) {
    remaining = 0;
  }
  return formatDataAmount(remaining);
}

class DataRemaining extends Component {
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    if (this.props.subId !== oldProps.subId) {
      this.fetchData();
    }
  }

  fetchData() {
    const { subId, findCurrentUsage, fetchCycles } = this.props;
    if (!subId) { return; }
    findCurrentUsage(subId);
    fetchCycles(subId);
  }

  render() {
    const { usage, currentCycle, currentPlan } = this.props;
    if (!usage || !currentCycle) { return null; }

    const [remaining, remainingUnit] = formatRemainingData(usage.mb_avail, usage.mb_used);
    const [timeLeft, timeUnit] = timeLeftInCycle(currentCycle.end_date);

    if (currentPlan && isUnlimited(currentPlan)) {
      return null;
    }

    return (
      <Box className={styles.DataRemaining}>
        <div className={styles.columns}>
          <div className={styles.cycleInfo}>
            <h2 className={styles.cycleHeader}>Current Cycle</h2>
            <div>
              {formatDate(currentCycle.start_date, SHORT_DATE_FORMAT)}
              {' - '}
              {formatDate(currentCycle.end_date, SHORT_DATE_FORMAT)}
            </div>
            <div>
              {timeLeft} {timeUnit} left
            </div>
          </div>
          <div className={cn(styles.dataInfo, remainingUnit === 'MB' && styles.warning)}>
            <span className={styles.remainingData}>
              {remaining}
            </span>
            <span>
              {remainingUnit}
            </span>
            <br />
            <span>
              remaining
            </span>
          </div>
        </div>
      </Box>
    )
  }
}

export default DataRemaining;
